"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackCtaClicked = trackCtaClicked;
exports.trackCtaViewed = trackCtaViewed;
exports.trackCtaListViewed = trackCtaListViewed;
exports.CTA_TYPES = exports.CtaType = void 0;

var _trackingHelper = require("../trackingHelper");

// @ts-check
var CtaType;
exports.CtaType = CtaType;

(function (CtaType) {
  CtaType["BUTTON"] = "BUTTON";
  CtaType["CHECKOUT"] = "CHECKOUT";
  CtaType["DEEP_LINK"] = "DEEP_LINK";
  CtaType["ICON"] = "ICON";
  CtaType["IMAGE"] = "IMAGE";
  CtaType["MODULE"] = "MODULE";
  CtaType["LINK"] = "LINK";
  CtaType["MARKETING_MODULE"] = "MARKETING_MODULE";
  CtaType["MARKETING_MODULE_LARGE"] = "MARKETING_MODULE_LARGE";
  CtaType["SAMPLES_PREVIEW"] = "SAMPLES_PREVIEW";
  CtaType["SHOW_MORE"] = "SHOW_MORE";
  CtaType["STARTING_TOOLS"] = "STARTING_TOOLS";
  CtaType["TOGGLE"] = "TOGGLE";
  CtaType["SHARE"] = "SHARE";
})(CtaType || (exports.CtaType = CtaType = {}));

var CTA_TYPES = {
  BUTTON: CtaType.BUTTON,
  CHECKOUT: CtaType.CHECKOUT,
  DEEP_LINK: CtaType.DEEP_LINK,
  ICON: CtaType.ICON,
  IMAGE: CtaType.IMAGE,
  MODULE: CtaType.MODULE,
  LINK: CtaType.LINK,
  MARKETING_MODULE: CtaType.MARKETING_MODULE,
  MARKETING_MODULE_LARGE: CtaType.MARKETING_MODULE_LARGE,
  SAMPLES_PREVIEW: CtaType.SAMPLES_PREVIEW,
  SHOW_MORE: CtaType.SHOW_MORE,
  STARTING_TOOLS: CtaType.STARTING_TOOLS,
  TOGGLE: CtaType.TOGGLE,
  SHARE: CtaType.SHARE
};
exports.CTA_TYPES = CTA_TYPES;

/**
 * @param eventData - Event data
 */
function trackCtaClicked(eventData) {
  (0, _trackingHelper.trackEvent)('CTA Clicked', eventData);
}
/**
 * @param eventData - Event data
 */


function trackCtaViewed(eventData) {
  (0, _trackingHelper.trackEvent)('CTA Viewed', eventData);
}

function trackCtaListViewed(eventData) {
  if (JSON.stringify(eventData.ctas).length > 1024) {
    // eslint-disable-next-line no-console
    console.debug('CTA List Viewed event is over the character limit.');
  } else {
    (0, _trackingHelper.trackEvent)('CTA List Viewed', eventData);
  }
}